import i18n from 'i18n';
import React from 'react';
import { ListAllLogs } from 'containers/Logs';
import { useParams } from 'react-router';
import ClientsTemplate from '../Templates/Clients';

const AuditClients = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <ClientsTemplate
      current="audit"
      breadcrumbs={[
        {
          name: i18n.t('CLIENTS_KEY'),
          link: '/clients',
        },
        {
          name: i18n.t('LOGS_PAGE.LIST_LOGS_TITLE_KEY'),
        },
      ]}
    >
      <ListAllLogs
        title={i18n.t('LOGS_PAGE.LIST_LOGS_KEY')}
        subtitle={i18n.t('LOGS_PAGE.LIST_LOGS_CLIENTS_KEY')}
        context={'client'}
        contextId={id}
        isContextPage
      />
    </ClientsTemplate>
  );
};

export default AuditClients;
